import { render, staticRenderFns } from "./CityDorms.vue?vue&type=template&id=4b6f7d12&scoped=true&"
import script from "./CityDorms.vue?vue&type=script&lang=js&"
export * from "./CityDorms.vue?vue&type=script&lang=js&"
import style0 from "./CityDorms.vue?vue&type=style&index=0&id=4b6f7d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f7d12",
  null
  
)

component.options.__file = "CityDorms.vue"
export default component.exports